// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__RAsdB","link":"Footer_link__sgKeT","paragraph":"Footer_paragraph__efOK8","author":"Footer_author__Lpa3K","logo":"Footer_logo__w79hm"};